<vdw-ellipsis-label [text]="tooltip" matTooltipPosition="above"></vdw-ellipsis-label>
